/*
	@license Angular Treeview version 0.1.6
	ⓒ 2013 AHN JAE-HA http://github.com/eu81273/angular.treeview
	License: MIT


	[TREE attribute]
	angular-treeview: the treeview directive
	tree-id : each tree's unique id.
	tree-model : the tree model on $scope.
	node-id : each node's id
	node-label : each node's label
	node-children: each node's children

	<div
		data-angular-treeview="true"
		data-tree-id="tree"
        data-tree-template="true"
		data-tree-model="roleList"
		data-node-id="roleId"
		data-node-label="roleName"
		data-node-children="children" >
	</div>
*/

(function (angular) {
    'use strict';

    angular.module('angularTreeview', []).directive('treeModel', ['$compile', function ($compile) {
        return {
			restrict: 'A',
            link: function (scope, element, attrs) {
                //tree id
                var treeId = attrs.treeId;

				var isNolink = (attrs.noLink === 'true');
                //tree model
                var treeModel = attrs.treeModel;

                //node id
                var nodeId = attrs.nodeId || 'id';

                //node label
                var nodeLabel = attrs.nodeLabel || 'label';

                //children
				var nodeChildren = attrs.nodeChildren || 'children';
				
                //template
                var templateType = attrs.treeTemplate;

                var treeFlag = attrs.treeFlag;
                var wrapText = HandbookConfiguration.WrapTextInNavigationTree == 'True' ? true : false;
                //tree template
				var template = '';
				if (!wrapText) {
                    var strlink = '<a data-ng-href="/folder/{{node.id}}" data-ng-if="node.type > 4" class="label-node-tree"><span tabindex="0" data-ng-keypress="' + treeId + '.selectNodeLabel(node)" id="{{node.id}}-label-f" class="{{node.selected}}" data-ng-class="{\'ml-4\': node.childCount > 0, \'text-italic\': node.isForced}"  data-ng-click="' + treeId + '.selectNodeLabel(node)">{{node.' + nodeLabel + '}}</span></a>' +
                        '<a data-ng-href="/document/{{node.id}}" data-ng-if="node.type < 5" class="label-node-tree"><span tabindex="0" data-ng-keypress="' + treeId + '.selectNodeLabel(node)" id="{{node.id}}-{{node.virtualHandbookId}}-label" class="{{node.selected}}" data-ng-class="{\'ml-4\': node.childCount > 0, \'text-italic\': node.isForced}"  data-ng-click="' + treeId + '.selectNodeLabel(node)">{{node.' + nodeLabel + '}}</span></a>';
					var strNoLink = '<span tabindex="0" data-ng-keypress="' + treeId + '.selectNodeLabel(node)" id="{{node.id}}-label" class="{{node.selected}}" data-ng-class="{\'ml-4\': node.childCount > 0, \'text-italic\': node.isForced}"  data-ng-click="' + treeId + '.selectNodeLabel(node)">{{node.' + nodeLabel + '}}</span>';
                    template = '<ul id="sideBarTreeView">' +
                                    '<li data-ng-repeat="node in ' + treeModel + '">' +
                        '<i tabindex="0" data-ng-keypress="' + treeId + '.selectNodeHead(node)" class="fa fa-caret-right" data-ng-class="{\'ti-5\': node.childCount > 0}" data-ng-show="!node.collapsed && (node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8 || isProcessNode(node)) && node.childCount > 0" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                        '<i tabindex="0" data-ng-keypress="' + treeId + '.selectNodeHead(node)" class="fa fa-caret-down" data-ng-class="{\'ti-5\': node.childCount > 0}" data-ng-show="node.collapsed && (node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8 || isProcessNode(node)) && node.childCount > 0" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                                        '<i id="{{node.id}}-collapsed" class="collapsed-folder-{{node.type}}" data-ng-show="!node.collapsed && (node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8)" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                                        '<i id="{{node.id}}-expanded" class="expanded-folder-{{node.type}}" data-ng-show="node.collapsed && (node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8)" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                                        '<i class="document-{{node.type}}-{{node.levelType}} cursor-default" data-ng-class="{\'typcn typcn-link\': node.type == 2, \'typcn typcn-attachment\': node.type == 3}" data-ng-show="node.type == 1 || node.type == 2 || node.type == 3 || node.type == 4"></i> ' +
                                        '{0}' +
										'<div data-ng-show="node.collapsed" data-tree-id="' + treeId + '" data-tree-model="node.' + nodeChildren + '" data-node-id=' + nodeId + ' data-node-label=' + nodeLabel + ' data-node-children=' + nodeChildren + ' data-tree-flag="' + treeFlag + '"data-no-link="' + isNolink + '"></div>' +
                                     '</li>' +
						'</ul>';
					template = isNolink ? String.format(template, strNoLink) : String.format(template, strlink);
				} else {
                    var strlink = '<a style="display:table-cell;" data-ng-href="/folder/{{node.id}}" data-ng-if="node.type > 4" class="label-node-tree"><span style="display:table-cell;" tabindex="0" data-ng-keypress="' + treeId + '.selectNodeLabel(node)" id="{{node.id}}-label-f" class="{{node.selected}}" data-ng-class="{\'ml-4\': node.childCount > 0, \'text-italic\': node.isForced}"  data-ng-click="' + treeId + '.selectNodeLabel(node)">{{node.' + nodeLabel + '}}</span></a>' +
                        '<a style="display:table-cell;" data-ng-href="/document/{{node.id}}" data-ng-if="node.type < 5 " class="label-node-tree"><span style="display:table-cell;" tabindex="0" data-ng-keypress="' + treeId + '.selectNodeLabel(node)" id="{{node.id}}-{{node.virtualHandbookId}}-label" class="{{node.selected}}" data-ng-class="{\'ml-4\': node.childCount > 0, \'text-italic\': node.isForced}"  data-ng-click="' + treeId + '.selectNodeLabel(node)">{{node.' + nodeLabel + '}}</span></a>';
					var strNoLink = '<span style="display:table-cell;" tabindex="0" data-ng-keypress="' + treeId + '.selectNodeLabel(node)" id="{{node.id}}-label" class="{{node.selected}}" data-ng-class="{\'ml-4\': node.childCount > 0, \'text-italic\': node.isForced}"  data-ng-click="' + treeId + '.selectNodeLabel(node)">{{node.' + nodeLabel + '}}</span>';
                    template = '<ul id="sideBarTreeView">' +
                                '<li data-ng-repeat="node in ' + treeModel + '" style="white-space:normal;">' +
                        '<i style="margin-top:5px;float:left;" tabindex="0" data-ng-keypress="' + treeId + '.selectNodeHead(node)" class="fa fa-caret-right" data-ng-class="{\'ti-5\': node.childCount > 0}" data-ng-show="!node.collapsed && ((node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8) || isProcessNode(node)) && node.childCount > 0" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                        '<i style="margin-top:5px;float:left;" tabindex="0" data-ng-keypress="' + treeId + '.selectNodeHead(node)" class="fa fa-caret-down" data-ng-class="{\'ti-5\': node.childCount > 0}" data-ng-show="node.collapsed && ((node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8) || isProcessNode(node)) && node.childCount > 0" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                                        '<i style="float:left;height:20px;margin-top:-2px;" id="{{node.id}}-collapsed" class="collapsed-folder-{{node.type}}" data-ng-show="!node.collapsed && (node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8)" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                                        '<i style="float:left;height:20px;margin-top:-2px;" id="{{node.id}}-expanded" class="expanded-folder-{{node.type}}" data-ng-show="node.collapsed && (node.type == 5 || node.type == 6 || node.type == 7 || node.type == 8)" data-ng-click="' + treeId + '.selectNodeHead(node)"></i>' +
                                        '<i style="float:left;height:25px;margin-top:-2px;" class="document-{{node.type}}-{{node.levelType}} cursor-default" data-ng-class="{\'typcn typcn-link\': node.type == 2, \'typcn typcn-attachment\': node.type == 3}" data-ng-show="node.type == 1 || node.type == 2 || node.type == 3 || node.type == 4"></i> ' +
                                        '{0}' +
										'<div data-ng-show="node.collapsed" data-tree-id="' + treeId + '" data-tree-model="node.' + nodeChildren + '" data-node-id=' + nodeId + ' data-node-label=' + nodeLabel + ' data-node-children=' + nodeChildren + ' data-tree-flag="' + treeFlag + '"data-no-link="' + isNolink + '"></div>' +
                                    '</li>' +
						'</ul>';
					template = isNolink ? String.format(template, strNoLink) : String.format(template, strlink);
                }
                //tree template
                var template1 =
					'<ul>' +
						'<li data-ng-repeat="node in ' + treeModel + '">' +
							'<i class="document-{{node.type}}-{{node.levelType}} cursor-default" data-ng-class="{\'typcn typcn-link\': node.type == 2, \'typcn typcn-attachment\': node.type == 3}" data-ng-show="node.type == 1 || node.type == 2 || node.type == 3 || node.type == 4"></i> ' +
                            '<a data-ng-href="/document/{{node.id}}"  data-ng-class="node.selected" class="label-node-tree" data-ng-click="' + treeId + '.selectNodeLabel(node)">{{node.' + nodeLabel + '}}</a>' +
						'</li>' +
					'</ul>';
                //check tree id, tree model
                if (treeId && treeModel) {

                    //root node
                    if (attrs.angularTreeview) {

                        //create tree object if not exists
                        scope[treeId] = scope[treeId] || {};

                        //if node head clicks,
						scope[treeId].selectNodeHead = scope[treeId].selectNodeHead || function (selectedNode) {

                            //Collapse or Expand
                            selectedNode.collapsed = !selectedNode.collapsed;
                            if (selectedNode.collapsed) {
                                selectedNode.TreeFlag = treeFlag;
                                scope.selectNodeHead(selectedNode);
                            }
                        };

                        //if node label clicks,
                        scope[treeId].selectNodeLabel = scope[treeId].selectNodeLabel || function (selectedNode) {
                            var isSelectedFolder = selectedNode.selected == 'selected' || selectedNode.selected == 'selected-force';                            
                            if ((isSelectedFolder || !selectedNode.collapsed) && HandbookConfiguration.ToggleFolderUponClick.toUpperCase() == "TRUE") {

                                //Collapse or Expand
                                selectedNode.collapsed = !selectedNode.collapsed;
                                if (selectedNode.collapsed) {
                                    selectedNode.TreeFlag = treeFlag;
                                    scope.selectNodeHead(selectedNode);
                                }
                            }

                            //remove highlight from previous node
                            if (scope[treeId].currentNode && scope[treeId].currentNode.selected) {
                                scope[treeId].currentNode.selected = undefined;
                            }

                            //Check treeId when call scope.selectNodeLabel
                            selectedNode.treeId = treeId;

                            scope.selectNodeLabel(selectedNode);

                            if (selectedNode.isForced) {
                                //set highlight to selected node
                                selectedNode.selected = 'selected-force';
                            } else {
                                //set highlight to selected node
                                selectedNode.selected = 'selected';
                            }

                            //set currentNode
                            scope[treeId].currentNode = selectedNode;
                        };
                    }

                    //Rendering template.
                    if (templateType) {
                        element.html('').append($compile(template1)(scope));
                    } else {
                        element.html('').append($compile(template)(scope));
                    }

                }
            }
        };
    }]);
})(angular);
